/**
 * 测量模式支持「仅面积 + 周长」的有边界解析曲面类型集合。
 *
 * 设计说明：
 * 1. 与 SolidWorks Measure 对齐：圆锥/圆环/B样条曲面不暴露解析半径；
 * 2. 集中维护支持集合，避免分类与标签映射散落重复。
 */
export const MEASURE_BOUNDED_SURFACE_KINDS: ReadonlySet<TopologySurfaceKind> = new Set([
    'cone',
    'torus',
    'bspline',
]);

/**
 * 判断曲面类型是否属于测量模式下的有边界面域（仅面积与周长）。
 *
 * @param surfaceKind 拓扑曲面类型。
 * @returns 是否支持测量面积与周长。
 */
export function isMeasureBoundedSurfaceKind(
    surfaceKind: TopologySurfaceKind | undefined,
): surfaceKind is TopologySurfaceKind {
    return typeof surfaceKind === 'string' && MEASURE_BOUNDED_SURFACE_KINDS.has(surfaceKind);
}

/**
 * 按曲面类型解析测量浮窗实体类型标签。
 *
 * @param surfaceKind 拓扑曲面类型。
 * @returns 中文类型标签。
 */
export function resolveBoundedSurfaceKindLabel(surfaceKind: TopologySurfaceKind): string {
    switch (surfaceKind) {
        case 'cone':
            return '圆锥曲面';
        case 'torus':
            return '圆环曲面';
        case 'bspline':
            return 'B样条曲面';
        default:
            return '曲面';
    }
}
